import { createPageSegmentLoadMetric, BLOG_TREE_SEGMENT_KEY } from '@confluence/browser-metrics';

export const BLOG_TREE_METRIC = createPageSegmentLoadMetric({
	key: BLOG_TREE_SEGMENT_KEY,
});
